export default {
  GET_ITEMS(state) {
      return state.statis_artisans
  },
  GET_ITEM(state,id) {
    state.statis_artisans.find((item) => item.id == id)
  },

  GET_INTERVENTIONS_STATISTICS(state) {
    return state.statis_interventions
}
}
